import React from 'react';
import { connect } from 'react-redux';
import { globalFieldLengths } from '@/constants/fields';
import DictionaryFieldValue from './DictionaryFieldValue';
import DictionaryInput from '../../dictionaries/components/DictionaryInput';
import DictionaryFieldContainer, {
  mapDispatchToProps,
  mapStateToProps,
} from '../components/DictionaryFieldContainer';

const DictionaryFieldNameTableCell = ({
  canEdit,
  canRead,
  category,
  code,
  constraint,
  dictionaryUUID,
  exists,
  fieldUUID,
  isEditing,
  name,
  showFieldDialog,
  template,
  updateProperties,
}) => (
  <>
    {isEditing && (
      <DictionaryFieldContainer category={category} code={code} exists={exists} canRead={canRead} canEdit={canEdit}>
        <DictionaryInput
          fluid
          type="field.name"
          text={name}
          onChange={(value) => (updateProperties(category, code, dictionaryUUID, { name: value }, fieldUUID, template))}
          maxLength={globalFieldLengths.dictionaryFieldName}
        />
      </DictionaryFieldContainer>
    )}
    {!isEditing && (
      <DictionaryFieldValue
        canRead={canRead}
        canEdit={canEdit}
        category={category}
        code={code}
        href="#"
        onClick={() => showFieldDialog(category, code, fieldUUID, constraint, canEdit)}
        value={name}
      />
    )}
  </>
);

export default connect(mapStateToProps, mapDispatchToProps)(DictionaryFieldNameTableCell);
